import {theme} from '@logistics-frontend/blocks/lpc/theme'
import {makeStyles} from '@material-ui/core/styles'

import bigCargoCar from './requirement/images/bigCargoCar.png'
import mediumCargoImage from './requirement/images/mediumCargoCar.png'
import smallCargoImage from './requirement/images/smallCargoCar.png'

export const useClasses = makeStyles({
  container: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      flexWrap: 'nowrap',
    },
  },
  title: {
    lineHeight: '16px',
  },
  boldTitle: {
    // проблема старых типов
    // eslint-disable-next-line
    fontWeight: theme.typography.fontWeightMedium as any,
    fontSize: 18,
    lineHeight: '26px',
  },
  subtitle: {
    fontSize: 12,
    lineHeight: '17px',
    fontWeight: 400,
    opacity: '.5',
  },
  image: {
    height: '100%',
    background: 'no-repeat center',
    backgroundSize: '100% auto',
    [theme.breakpoints.down('sm')]: {
      backgroundSize: 'contain',
    },
  },
  image_van: {
    backgroundImage: `url(${smallCargoImage})`,
    [theme.breakpoints.down('sm')]: {
      minHeight: 200,
    },
  },
  image_lcv_m: {
    backgroundImage: `url(${mediumCargoImage})`,
    [theme.breakpoints.down('sm')]: {
      minHeight: 200,
    },
  },
  image_lcv_l: {
    backgroundImage: `url(${bigCargoCar})`,
    [theme.breakpoints.down('sm')]: {
      minHeight: 200,
    },
  },
  counter: {
    padding: '0 15px',
    minWidth: 40,
    textAlign: 'center',
  },
  buttonsContainer: {
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
    },
  },
  buttonError: {
    outline: `2px solid ${theme.palette.error.main}`,
  },
  formControlLabel: {
    padding: theme.spacing(0.5, 0),
  },
})

export const useButtonClasses = makeStyles({
  root: {
    fontFamily: 'YS Text',
    minWidth: 'auto',
    borderRadius: 15,
    backgroundColor: theme.palette.grey[300],
    color: theme.palette.secondary.dark,
    height: 35,
    fontSize: 27,
    padding: '0 10px',
    margin: 0,
    '&:hover': {
      backgroundColor: theme.palette.grey[400],
    },
  },
  label: {
    lineHeight: '35px',
  },
})
